import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import authentication from "./authentication";
import events from "./events";
import students from "./students";
import measurements from "./measurements";

const rootReducer = combineReducers({
  authentication,
  events,
  students,
  measurements,
  routing: routerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./reducers/index.js